export default "__VITE_PUBLIC_ASSET__3c197d90__"